import React, {useEffect, useState} from "react";
import "../../../pages/Structure/Structure.css";
import {OrganizationChart} from "primereact/organizationchart";
import axios from "axios";
import {MdDeleteForever, MdEdit} from "react-icons/md";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
} from "@mui/material";
import {BiSolidCategoryAlt} from "react-icons/bi";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";

const StructurePageManager = () => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [isAdding, setIsAdding] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
    const [organizationStructures, setOrganizationStructures] = useState([]);
    const [deleteId, setDeleteId] = useState(null);
    const [shouldRefetch, setShouldRefetch] = useState(false);
    const [organizationStructuresOrgChart, setOrganizationStructuresOrgChart] = useState([null]);
    const [formData, setFormData] = useState({
        id: 0,
        position: "",
        name: "",
        DescriptionShort: "",
        description: "",
        positionEng: "",
        nameEng: "",
        descriptionShortEng: "",
        descriptionEng: "",
        Level: 0,
        parentId: 0,
        fullName: ''
    });

    const [editFormData, setEditFormData] = useState({
        id: 0,
        position: "",
        name: "",
        DescriptionShort: "",
        description: "",
        positionEng: "",
        nameEng: "",
        descriptionShortEng: "",
        descriptionEng: "",
        Level: 0,
        parentId: 0,
        fullName: ''
    });

    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const fetchOrganizationStructures = async () => {
        try {
            const response = await axios.get(
                `${baseURL}/GetAllOrganizationStructure`
            );
            const data = response.data;
            setOrganizationStructures(data);
            return data.success ? data.data : [];
        } catch (error) {
            return [];
        }
    };

    useEffect(() => {
        fetchOrganizationStructures().then((data) => {
            setOrganizationStructures(data);
        });
    }, [organizationStructures]);


    useEffect(() => {

        if (organizationStructures.length > 0) {
            organizeData();
        }
    }, [organizationStructures]);

    const nodeStyle = {
        width: "250px",
        border: "1px solid #ccc",
        borderRadius: "5px",
        padding: "10px",
        background: "#f0f0f0",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
    };
    const headerStyle = {
        margin: "0",
        maxWidth: "100%",
        maxHeight: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
    };
    const nodeTemplate = (node) => {

        return (
            <div style={nodeStyle}>
                <div className="" style={headerStyle}>
                    {node.label}
                </div>
                <div>
                    {node.fullName}
                </div>
                <div className="node-content">
                    <MdEdit
                        style={{fontSize: 40, cursor: "pointer", color: "black"}}
                        onClick={() => handleOpenEditDialog(node)}
                    />

                    <BiSolidCategoryAlt
                        style={{
                            marginLeft: "10px",
                            fontSize: 40,
                            cursor: "pointer",
                            color: "#3872F2",
                        }}
                        onClick={() => handleOpenDialog(node)}
                    >
                        + ელემენტის შექმნა
                    </BiSolidCategoryAlt>
                    {!node.children[0] ? (
                        <MdDeleteForever
                            style={{
                                marginLeft: "10px",
                                fontSize: 40,
                                cursor: "pointer",
                            }}
                            onClick={() => handleOpenDeleteDialog(node.id)}
                        ></MdDeleteForever>
                    ) : (
                        ""
                    )}

                </div>
            </div>
        );

    };

    const organizeData = () => {
        const result = [];

        const nodesByLevel = [];

        organizationStructures.forEach((item) => {
            if (!nodesByLevel[item.level]) {
                nodesByLevel[item.level] = [];
            }
        });

        // Populate nodesByLevel with nodes
        organizationStructures.forEach((item) => {
            const node = {
                // className: 'p-person',
                id: item.id,
                label: item.name,
                fullName: item.fullName,
                position: item.position,
                name: item.name,
                descriptionShort: item.descriptionShort,
                description: item.description,
                positionEng: item.positionEng,
                nameEng: item.nameEng,
                descriptionShortEng: item.descriptionShortEng,
                descriptionEng: item.descriptionEng,
                level: item.level,
                parentId: item.parentId,
                expanded: true,
                children: [],
            };
            nodesByLevel[item.level].push(node);
        });

        nodesByLevel.forEach((nodes, level) => {
            nodes.forEach((node) => {
                const parentId = organizationStructures.find(
                    (item) => item.id === node.id
                ).parentId;
                if (parentId === null) {
                    result.push(node);
                } else {
                    const parentNode = nodesByLevel[level - 1].find(
                        (parent) => parent.id === parentId
                    );
                    if (parentNode) {
                        parentNode.children.push(node);
                    }
                }
            });
        });
        setOrganizationStructuresOrgChart(result);
        return result;
    };

    const handleOpenEditDialog = (item) => {
        setEditFormData({
            ...editFormData,
            id: item.id,
            label: item.name,
            position: item.position,
            name: item.name,
            descriptionShort: item.descriptionShort,
            description: item.description,
            positionEng: item.positionEng,
            nameEng: item.nameEng,
            descriptionShortEng: item.descriptionShortEng,
            descriptionEng: item.descriptionEng,
            level: item.level,
            parentId: item.parentId,
            fullName: item.fullName,
        });
        setEditDialogOpen(true);
    };
    const handleEditChange = (event) => {
        setEditFormData({
            ...editFormData,
            [event.target.name]: event.target.value,
        });
    };
    const [editConfirmationModalOpen, setEditConfirmationModalOpen] = useState(false);
    const handlePreEditSubmit = () => {
        setEditConfirmationModalOpen(true);
    };

    const handleActualEditSubmit = async () => {
        setIsLoading(true);
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_API_BASE_URL}/EditOrganizationStructure`,
                editFormData
            );
            setShouldRefetch(true);
            //fetchOrganizationStructures();
        } catch (error) {
        } finally {
            setIsLoading(false);
            setEditDialogOpen(false);
            setEditConfirmationModalOpen(false);
        }
    };
    const handleOpenDialog = (node) => {
        setFormData({...formData, level: node.level + 1, parentId: node.id});
        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };
    const handleSubmit = async () => {
        setIsAdding(true);
        setConfirmationModalOpen(false);
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/AddNewOrganizationStructure`,
                formData
            );
        } catch (error) {
            console.error("Error submitting form:", error);
        } finally {
            setIsAdding(false);
            handleCloseDialog();
            await fetchOrganizationStructures();
        }
    };
    const handlePreSubmit = () => {
        setConfirmationModalOpen(true);
    };
    const handleChange = (event) => {
        setFormData({...formData, [event.target.name]: event.target.value});
    };

    const handleOpenDeleteDialog = (id) => {
        setDeleteId(id);
        setDeleteDialogOpen(true);
    };

    const handleCloseDeleteDialog = () => {
        setDeleteDialogOpen(false);
    };
    const handleDeleteSubmit = async () => {
        if (deleteId !== null) {
            setIsDeleting(true);
            try {
                const response = await axios.put(
                    `${process.env.REACT_APP_API_BASE_URL}/DeleteOrganizationStructure`,
                    {id: deleteId}
                );
            } catch (error) {
                console.error("Error deleting organization structure:", error);
            } finally {
                setIsDeleting(false);
                setDeleteDialogOpen(false);
                await fetchOrganizationStructures();
            }
        }
    };
    return (
        <div>
            <br></br>
            {organizationStructuresOrgChart[0] ? (
                <div className="organizationchart-demo" style={{width: "100%"}}>
                    <div className="card">
                        <OrganizationChart
                            value={organizationStructuresOrgChart}
                            nodeTemplate={nodeTemplate}
                            className="company"
                        ></OrganizationChart>
                    </div>
                </div>
            ) : (
                ""
            )}
            <ConfirmationModal
                isOpen={editConfirmationModalOpen}
                onRequestClose={() => setEditConfirmationModalOpen(false)}
                onConfirm={handleActualEditSubmit}
                title="შეცვლის დასტური"
                message="სტრუქტურის ელემენტის შეცვლაზე დარწმუნებული ხართ?"
            />
            <Dialog
                style={{zIndex: 500}}
                open={dialogOpen}
                onClose={handleCloseDialog}
            >
                <DialogTitle>სტრუქტურის ელემენტის დამატება</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        name="name"
                        label="სათაური"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={formData.name}
                        onChange={handleChange}
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        name="nameEng"
                        label="სათაური ინგლისურად"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={formData.nameEng}
                        onChange={handleChange}
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        name="fullName"
                        label="სახელი"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={formData.fullName}
                        onChange={handleChange}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog}>გაუქმება</Button>
                    <Button onClick={handlePreSubmit}>დამატება</Button>
                </DialogActions>
            </Dialog>
            <ConfirmationModal
                isOpen={confirmationModalOpen}
                onRequestClose={() => setConfirmationModalOpen(false)}
                onConfirm={handleSubmit}
            />
            <ConfirmationModal
                isOpen={deleteDialogOpen}
                onRequestClose={handleCloseDeleteDialog}
                onConfirm={handleDeleteSubmit}
            />
            <Dialog open={editDialogOpen} onClose={() => setEditDialogOpen(false)}>
                <DialogTitle>სტრუქტურის ელემენტის შეცვლა</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        name="name"
                        label="სათაური"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={editFormData.name}
                        onChange={handleEditChange}
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        name="nameEng"
                        label="სათაური ინგლისურად"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={editFormData.nameEng}
                        onChange={handleEditChange}
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        name="fullName"
                        label="სრული სახელი"
                        type="fullName"
                        fullWidth
                        variant="standard"
                        value={editFormData.fullName}
                        onChange={handleEditChange}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setEditDialogOpen(false)}>გაუქმება</Button>
                    <Button onClick={handlePreEditSubmit}>შენახვა</Button>
                </DialogActions>
                <ConfirmationModal
                    isOpen={editConfirmationModalOpen}
                    onRequestClose={() => setEditConfirmationModalOpen(false)}
                    onConfirm={handleActualEditSubmit}
                    title="შეცვლის დასტური"
                    message="ნებართვის ტიპის შეცვლაზე დარწმუნებული ხართ?"
                />
                <ConfirmationModal
                    isOpen={confirmationModalOpen}
                    onRequestClose={() => setConfirmationModalOpen(false)}
                    onConfirm={handleSubmit}
                />
            </Dialog>
        </div>
    );
};

export default StructurePageManager;
